import { useState } from "react";
import { getPlaceholderName } from "../../utils/general";

export const setDefaultTextForImage = (name = "") => {
  return name
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase())
    .slice(0, 2)
    .join("");
};

export const DisplayImage = ({ path = null, name = "" }) => {
  const [error, setError] = useState(false);
  return (
    <>
      {path && !error ? (
        <img class="appimage-small" src={path} onError={() => setError(true)} />
      ) : (
        <span className="initial-small">{setDefaultTextForImage(name)}</span>
      )}
    </>
  );
};
